import { Bitmap, BitmapData, MovieClip, Point, Rectangle } from "../runtime";
import { SPR_cleanser } from "./assets";

/** Sprite-sheet row width, in pixels. */
const ROW_X = 320;

/**
 * The Cleanser: a full-height wall of energy that sweeps left to right across
 * the level, tiling one 25-frame 64px beam sprite down its whole length. It
 * coasts for 45 frames, stalls, and only starts chasing the player once
 * `alterState` is called. `update` returns how close it is, for the siren.
 */
export class Cleanser extends MovieClip {
  xPos = 0;
  private readonly tileSize = 64;
  private readonly rowLength: number;
  private readonly beamTotal: number;
  private readonly tileRect: Rectangle;
  private readonly tilePoint: Point;
  private readonly tileSheetBitmapData: BitmapData;
  private readonly canvasBitmapData: BitmapData;
  private frame = 0;
  private life = 0;
  private speedTarget = 0;
  private speedCurrent = 0;
  private moving = false;

  constructor(levelY: number) {
    super();
    this.beamTotal = Math.ceil(levelY / this.tileSize) + 1;
    this.tilePoint = new Point(0, 0);
    this.tileSheetBitmapData = new SPR_cleanser();
    this.rowLength = (ROW_X / this.tileSize) | 0;
    this.tileRect = new Rectangle(0, 0, this.tileSize, this.tileSize);
    this.canvasBitmapData = new BitmapData(
      this.tileSize,
      levelY + this.tileSize,
      true,
    );
    const canvasBitmap = new Bitmap(this.canvasBitmapData);
    this.addChild(canvasBitmap);
    canvasBitmap.x = this.tileSize * -0.5;
    this.y = this.tileSize * -0.5;
    this.drawFrame();
    this.speedTarget = 100;
    this.speedCurrent = this.speedTarget;
  }

  /** Returns the siren pitch: higher the closer the wall is to catching up. */
  update(playerX: number): number {
    if (this.speedCurrent < this.speedTarget) {
      this.speedCurrent += 5;
    }
    if (this.speedCurrent > this.speedTarget) {
      this.speedCurrent -= 5;
    }
    if (this.moving) {
      let newSpeed = ((playerX - this.x) * 0.25 + 15) | 0;
      if (newSpeed > 200) {
        newSpeed = 200;
      }
      if (newSpeed < 30) {
        newSpeed = 30;
      }
      this.speedTarget = newSpeed;
    }
    if (this.life < 300) {
      ++this.life;
      if (this.life === 45) {
        this.speedTarget = 0;
      }
    }
    this.x += this.speedCurrent * 0.025;
    this.xPos = this.x + 30;
    ++this.frame;
    if (this.frame === 25) {
      this.frame = 0;
    }
    this.drawFrame();
    return (this.speedTarget * -1 + 245) | 0;
  }

  /** Wakes the wall up so it starts homing in on the player. */
  alterState(): void {
    this.moving = true;
  }

  private drawFrame(): void {
    this.tileRect.x = ((this.frame % this.rowLength) | 0) * this.tileSize;
    this.tileRect.y = ((this.frame / this.rowLength) | 0) * this.tileSize;
    for (let beamIndex = 0; beamIndex < this.beamTotal; beamIndex++) {
      this.tilePoint.y = beamIndex * this.tileSize;
      this.canvasBitmapData.copyPixels(
        this.tileSheetBitmapData,
        this.tileRect,
        this.tilePoint,
      );
    }
  }
}
